import { Injectable } from '@angular/core';

import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgressService } from './progress.service';
import { environment } from 'src/environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { AppTokenHandler } from './app-token-handler';
import { catchError } from 'rxjs/operators';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class LoginService {
  public redirectUrl: string | null = null;

  constructor(
    private appToken: AppTokenHandler,
    private http: HttpClient,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private gservice: DataService,
    //private spinnerService: ProgressService
  ) { }

  login(azureToken: string = ''): Observable<any> {
    const dummyEmail = sessionStorage.getItem('dummyEmail');
    const url = dummyEmail ? `/?email=${dummyEmail}` : '';

    const tokenpath = `${environment.serviceBaseUrl}Token${url}`;

    const headers = {
      headers: new HttpHeaders({
        azure_token: azureToken,
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
    return this.http.get(tokenpath, headers).pipe(catchError(this.handleError));
  }

  // getUserDetails(expectedRole: any, azureToken: string = '') {
  //   this.login(azureToken).subscribe({
  //     next: (data: any) => {
  //       if (data) {
  //         if (data.isAuthenticated) {
  //           this.SetSessionAndNavigate(data, expectedRole);
  //         } else {
  //           this.router.navigate(['/error/1']);
  //         }
  //       } else {
  //         this.router.navigate(['/error/1']);
  //       }
  //     },
  //     error: (err: any) => {
  //       this.router.navigate(['/error/2']);
  //     },
  //   });
  // }

  GetUserDetails(azure_token: string) {
    this.gservice.Login('', azure_token).subscribe((data: any) => {
      if (data.IsAuthenticated) {
        this.SetSessionAndNavigate(data, null);
      } else {
        this.router.navigate(['/error/1']);
      }
    }, (error: Response) => {
      if (error.status <= 0) {
        this.router.navigate(['/error/2']);
      } else if (error.status === 401) {
        this.router.navigate(['/error/1']);
      } else {
        this.router.navigate(['/error/2']);
      }
    }, () => {
    });
    // }
    //  else {
    //   // this.route.navigate(['/home']);
    //   this.router.navigate(['/dashboard']);
    //}
  }

  SetSessionAndNavigate(loginData: any, expectedRole: any) {
    this.appToken.setSessionToken(loginData);

    this.activeRoute.queryParams.subscribe(() => {

      const redirectUrl = sessionStorage.getItem('redirectUrl');

      if (this.redirectUrl === null && redirectUrl && redirectUrl.length > 0) {
        this.redirectUrl = redirectUrl;
      }

      console.log('this.redirectUrl in login.service.ts: ', this.redirectUrl);

      if (!this.redirectUrl) {
        this.router.navigate(['/home']);
      }
      else {
        sessionStorage.setItem('redirectUrl', '');
        this.router.navigate([this.redirectUrl]);
        this.redirectUrl = null;
      }
    });
  }

  LogoutUser(_url: string) {
    _url = environment.serviceBaseUrl + _url;
    return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${error.error.message}`;
    } else {
      errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
